export default {
  name: 'marking--mrkExStatus',
};